var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vs-popup",
    {
      attrs: { active: _vm.isActive, title: "" },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
        close: _vm.close,
      },
    },
    [
      _c("div", { staticClass: "state-change-popup" }, [
        _c("button", { staticClass: "popup-close", on: { click: _vm.close } }, [
          _vm._v("✕"),
        ]),
        !_vm.isProcessing
          ? _c("div", { staticClass: "popup-body" }, [
              _c(
                "div",
                {
                  class: [
                    "popup-icon",
                    _vm.isCanceling ? "icon-danger" : "icon-success",
                  ],
                },
                [
                  _c("feather-icon", {
                    attrs: {
                      icon: _vm.isCanceling
                        ? "AlertTriangleIcon"
                        : "CheckCircleIcon",
                      svgClasses: "w-10 h-10",
                    },
                  }),
                ],
                1
              ),
              _c("h3", { staticClass: "popup-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.isCanceling
                      ? "Anular facturación"
                      : "Confirmar facturación"
                  )
                ),
              ]),
              _c("p", { staticClass: "message" }, [
                _vm._v(_vm._s(_vm.popupMessage)),
              ]),
              !_vm.isCanceling && _vm.billingComments.length
                ? _c("div", { staticClass: "billing-comments-note" }, [
                    _c("p", { staticClass: "billing-comments-title" }, [
                      _vm._v("Comentario de facturación:"),
                    ]),
                    _c(
                      "ul",
                      _vm._l(_vm.billingComments, function (item, index) {
                        return _c("li", { key: index }, [
                          _vm.billingComments.length > 1
                            ? _c("strong", [
                                _vm._v("Cierre #" + _vm._s(item.number) + ": "),
                              ])
                            : _vm._e(),
                          _vm._v(_vm._s(item.comment) + "\n          "),
                        ])
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm.isCanceling
                ? _c(
                    "div",
                    { staticClass: "cancel-comment" },
                    [
                      _c("label", { staticClass: "cancel-comment-label" }, [
                        _vm._v("Comentario"),
                      ]),
                      _c("vs-textarea", {
                        attrs: {
                          rows: 3,
                          maxlength: "1000",
                          placeholder:
                            "Indique el motivo de anulación, campo obligatorio",
                        },
                        model: {
                          value: _vm.cancellationComment,
                          callback: function ($$v) {
                            _vm.cancellationComment = $$v
                          },
                          expression: "cancellationComment",
                        },
                      }),
                      _vm.cancellationComment.trim().length > 0 &&
                      _vm.cancellationComment.trim().length < 10
                        ? _c("p", { staticClass: "cancel-comment-hint" }, [
                            _vm._v(
                              "\n          Mínimo 10 caracteres.\n        "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm.isProcessing
          ? _c(
              "div",
              { staticClass: "processing" },
              [
                _c("vs-loading"),
                _c("p", [_vm._v("Procesando cambio de estado...")]),
              ],
              1
            )
          : _vm._e(),
        _vm.errorMessage
          ? _c(
              "div",
              { staticClass: "error-message" },
              [
                _c(
                  "vs-alert",
                  { staticClass: "mb-3", attrs: { color: "danger" } },
                  [_vm._v(_vm._s(_vm.errorMessage))]
                ),
              ],
              1
            )
          : _vm._e(),
        !_vm.isProcessing
          ? _c(
              "div",
              { staticClass: "popup-actions" },
              [
                _c(
                  "vs-button",
                  { attrs: { type: "border" }, on: { click: _vm.close } },
                  [_vm._v("Cancelar")]
                ),
                _c(
                  "vs-button",
                  {
                    attrs: {
                      color: _vm.isCanceling ? "danger" : "primary",
                      disabled: !_vm.canProceed,
                    },
                    on: { click: _vm.handleConfirm },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.isCanceling ? "Sí, anular" : "Sí, facturar"
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }